export { PaginatedTable } from './PaginatedTable';
